export const isLowerResolution = resolution => window.innerWidth < resolution;

export const getCurrentUrl = () =>
  `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

export const getCurrentLocationHash = () => window.location.hash;

// eslint-disable-next-line
export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export const hasQueryStringParameter = key => window.location.href.indexOf(key) !== -1;

export const getValueFromUrl = key => {
  if (!key) {
    throw new Error('Parameter "key" should be specified');
  }

  let url = window.location.href;
  let regex = new RegExp(`[?&]${key}(=([^&#]*)|&|#|$)`, 'i');
  let result = regex.exec(url);

  if (!result || !result[2]) {
    return;
  }

  return decodeURIComponent(result[2].replace(/\+/g, ' '));
};

export const clearQueryString = () => {
  const currentHash = getCurrentLocationHash();
  const searchIndex = currentHash.indexOf('?');

  if (searchIndex !== -1) {
    const cleanHash = currentHash.slice(0, searchIndex);
    window.history.replaceState({}, document.title, `${getCurrentUrl()}${cleanHash}`);
  }
};

export const closeWindow = () => {
  if (window.opener && window !== window.opener) {
    window.close();
  }
};
